import { OfBaseApiTransport } from '@oneflow/ofs-vuex-crud';

const filesApiProviderInstance = new OfBaseApiTransport({ apiBase: window.$config.filesApi });

export default filesApiProviderInstance;
